(() => {
  if (customElements.get('veylo-desktop-navigation')) return;
  class VeyloDesktopNavigation extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dropdowns = [...this.querySelectorAll('.vf-dropdown')];
      const close = () => dropdowns.forEach(item => { item.open = false; });
      dropdowns.forEach(item => item.querySelector(':scope > summary').addEventListener('click', () => {
        if (!item.open) dropdowns.forEach(other => { if (other !== item) other.open = false; });
      }, options));
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const active = event.target.closest('.vf-dropdown[open]');
        if (active) { event.preventDefault(); active.open = false; active.querySelector('summary').focus(); }
      }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) close(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) close(); }, options);
      window.addEventListener('resize', close, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('veylo-desktop-navigation', VeyloDesktopNavigation);
})();
